const React = require('react');

const ConfigCard = require('../../../ConfigCard');
const {AdminFormRow, AdminFormCol} = require('../../../../../AdminLayout');

const GatewaySelect = require('./components/GatewaySelect');
const {PAYMENT_METHODS_LIST, GATEWAYS_LIST_FULL} = require('../../../../../../../../constants/paymentMethods/');

module.exports = ({formCtx}) => (
  <>
    <ConfigCard title="Payment Gateway" className="mt24">
      <AdminFormRow className="mt17">
        {PAYMENT_METHODS_LIST.map((method) => {

          const errors = ((formCtx || {}).state || {}).errors || {};

          const list = method.gatewaysList;

          // const list = errors[method.id]
          //   ? GATEWAYS_LIST_FULL.map((gateway) => {
          //     return method.gatewaysList.find((availableGateway) => availableGateway.id === gateway.id)
          //       ? gateway
          //       : {...gateway, disabled: true}
          //   }) : method.gatewaysList;

          return (
            <AdminFormCol key={method.id}>
              <GatewaySelect id={method.id} name={method.name} list={list} formCtx={formCtx} />
            </AdminFormCol>
          )
        })}
      </AdminFormRow>
    </ConfigCard>
  </>
)
